import React, { useEffect, useState } from "react";
import {
  //  Avatar, Dropdown, Menu,
  Col,
  Typography,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import SearchInput from "../../../components/Input/SearchInputs/SearchInput";
import CustomSelect from "../../../components/SelectableDropdown/CustomSelect/CustomSelect";
import DateRangePicker from "../../../components/DateRangePicker/DateRangePicker";
import CustomTableWithPagination from "../../../components/CustomTableWithPagination/CustomTableWithPagination";
import { useLazyGetCategoryWiseReportsQuery } from "../../../apis/reports";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";
import "./CategorySalesReport.css";

import dayjs from "dayjs";
import { saveAs } from "file-saver";
const { Text } = Typography;
const options = [
  {
    key: 1,
    value: "Export",
    label: "Export",
  },
];

const dateOptions = [
  {
    key: 1,
    value: "Today",
    label: "Today",
  },
  {
    key: 2,
    value: "Yesterday",
    label: "Yesterday",
  },
  {
    key: 3,
    value: "last_7_day",
    label: "Last 7 day",
  },
  {
    key: 4,
    value: "last_30_day",
    label: "Last 30 day",
  },
  {
    key: 5,
    value: "last_60_day",
    label: "Last 60 day",
  },
  {
    key: 6,
    value: "Custom",
    label: "Custom",
  },
];

const CategorySalesReport = () => {
  const [dateFilter, setDateFilter] = useState();
  const [searchedValue, setSearchedValue] = useState({});
  const [dateSearch, setDateSearch] = useState({
    start_date: "",
    end_date: "",
  });
  const [currentPage, setCurrentPage] = useState(1);

  const [
    getCategoryWiseSalesReportApi,
    { data: categoryWiseSalesReportData, isFetching },
  ] = useLazyGetCategoryWiseReportsQuery();
  useEffect(() => {
    getCategoryWiseSalesReportApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleChange = (value) => {
    let formattedDate = null;

    switch (value) {
      case "Today":
        formattedDate = dayjs().format("YYYY-MM-DD");
        break;
      case "Yesterday":
        formattedDate = dayjs().subtract(1, "day").format("YYYY-MM-DD");
        break;
      case "last_7_day":
        formattedDate = dayjs().subtract(6, "day").format("YYYY-MM-DD");
        break;
      case "last_30_day":
        formattedDate = dayjs().subtract(29, "day").format("YYYY-MM-DD");
        break;
      case "last_60_day":
        formattedDate = dayjs().subtract(59, "day").format("YYYY-MM-DD");
        break;
      case "Custom":
        formattedDate = "Custom";
        break;
      default:
        break;
    }

    const currentDate = dayjs().format("YYYY-MM-DD");
    if (value !== "Custom" && value !== null) {
      if (value === "clear_date") {
        getCategoryWiseSalesReportApi({
          ...(searchedValue?.search && { search: searchedValue?.search }),
          // ...(sorterState.rfq_id && { sort_by: sorterState.rfq_id }),
          // ...(sorterState.created_at && { sort_by: sorterState.created_at }),
          page: 1,
        });
        setDateSearch({
          start_date: "",
          end_date: "",
        });
      } else {
        getCategoryWiseSalesReportApi({
          start_date: formattedDate,
          end_date: currentDate,
          ...(searchedValue?.search && { search: searchedValue?.search }),
          // ...(sorterState.rfq_id && { sort_by: sorterState.rfq_id }),
          // ...(sorterState.created_at && { sort_by: sorterState.created_at }),
          page: 1,
        });
        setDateSearch({
          start_date: formattedDate,
          end_date: currentDate,
        });
      }
      setCurrentPage(1);
    }
    setDateFilter(value);
  };
  const handleChangeRangePicker = (dates, dateStrings) => {
    if (dates && dates.length === 2) {
      const startDateFormatted = dates[0].format("YYYY-MM-DD");
      const endDateFormatted = dates[1].format("YYYY-MM-DD");
      getCategoryWiseSalesReportApi({
        start_date: startDateFormatted,
        end_date: endDateFormatted,
        // ...(sorterState.rfq_id && { sort_by: sorterState.rfq_id }),
        // ...(sorterState.created_at && { sort_by: sorterState.created_at }),
      });
      setDateSearch({
        start_date: startDateFormatted,
        end_date: endDateFormatted,
      });
    }
  };

  const handleExportApi = async () => {
    console.log("dgdgh");
    let response = await getCategoryWiseSalesReportApi({
      ...(searchedValue.search && { search: searchedValue.search }),
      ...(dateSearch.start_date && { start_date: dateSearch.start_date }),
      ...(dateSearch.end_date && { end_date: dateSearch.end_date }),
      download: true,
    });
    if (response?.status === "fulfilled") {
      // handlePdfDownload(response?.data?.data?.url);
      saveAs(response?.data?.data?.url);
    }
  };

  const columns = [
    {
      title: "Material category",
      dataIndex: "material_category",
      key: "material_category",
      width: "300px",
      render: (params, record) => {
        return (
          <Col
            // onClick={() => handleUserDetailsNavigation(record)}
            style={{ fontWeight: 500, cursor: "pointer" }}
          >
            {params}
          </Col>
        );
      },
    },
    {
      title: "Subcategory 1",
      dataIndex: "subcategory_1",
      key: "subcategory_1",
      width: "250px",
    },
    {
      title: "Subcategory 2",
      dataIndex: "subcategory_2",
      key: "subcategory_2",
      width: "300px",
    },
    {
      title: "Qty",
      dataIndex: "qty",
      key: "qty",
      width: "150px",
    },
    {
      title: "Sales amount",
      dataIndex: "sales_amount",
      key: "sales_amount",
      width: "250px",
    },
    {
      title: "IGST",
      dataIndex: "IGST",
      key: "IGST",
      width: "150px",
      render: (parmas, record) => {
        return (
          <Col>
            <Text>{parmas}</Text>
          </Col>
        );
      },
    },
    {
      title: "CGST",
      dataIndex: "CGST",
      key: "CGST",
      width: "150px",
      render: (parmas, record) => {
        return (
          <Col>
            <Text>{parmas}</Text>
          </Col>
        );
      },
    },
    {
      title: "SGST",
      dataIndex: "SGST",
      key: "SGST",
      width: "150px",
      render: (parmas, record) => {
        return (
          <Col>
            <Text>{parmas}</Text>
          </Col>
        );
      },
    },
  ];

  const handlePageChange = async (currPage) => {
    const params = {
      page: currPage,
      ...(searchedValue && { search: searchedValue?.search }),
      ...(dateSearch.start_date && { start_date: dateSearch.start_date }),
      ...(dateSearch.end_date && { end_date: dateSearch.end_date }),
      // ...(sorterState.rfq_id && { sort_by: sorterState.rfq_id }),
      // ...(sorterState.created_at && { sort_by: sorterState.created_at }),
    };
    setCurrentPage(currPage);
    await getCategoryWiseSalesReportApi(params);
  };

  const handleSearchedValue = (params) => {
    setSearchedValue(params);
    setCurrentPage(1);
  };

  return (
    <Col className="SalesReport-wrapper">
      <Text className="heading">Category wise sales report</Text>
      <Col style={{ display: "flex", gap: "1rem" }}>
        <SearchInput
          size={"large"}
          placeholder={"Search by customer name, mobile no, email"}
          width={"400px"}
          getLibraryApi={getCategoryWiseSalesReportApi}
          handleSearchedValue={handleSearchedValue}
          isLoading={isFetching}
        />
        <Col className="action-sub-container">
          <CustomSelect
            placeholder={"Date"}
            width={"150px"}
            options={dateOptions}
            handleChange={handleChange}
            value={dateFilter}
          />
          {dateFilter === "Custom" && (
            <DateRangePicker
              onChange={handleChangeRangePicker}
              format={"DD-MMM-YYYY"}
            />
          )}
        </Col>
        <CustomSelect
          placeholder={"Export"}
          width={"150px"}
          options={options}
          handleChange={handleExportApi}
          value={isFetching ? <LoadingOutlined /> : "EXPORT"}
          disabled={isFetching ? true : false}
          loading={isFetching}
        />
      </Col>
      <CustomTableWithPagination
        className="order-list-table"
        //   tableExpandable={defaultExpandable}
        // tableDataSource={tableDataSource || []}
        tableDataSource={categoryWiseSalesReportData?.data?.results}
        tableColumns={columns}
        locale={{
          emptyText: isFetching ? <TableSkeleton length={10} /> : "",
        }}
        isLoading={
          categoryWiseSalesReportData?.data?.results?.length && isFetching
        }
        scroll={{ x: "100%" }}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
        itemsPerPage={30}
        totalEntries={
          !isFetching &&
          categoryWiseSalesReportData?.data?.pagination?.total_entries
        }
      />
    </Col>
  );
};

export default CategorySalesReport;
